// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-element{position:relative;width:100%;height:100%;overflow:hidden}.media-element video{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.media-element.locked-aspect-ratio img{position:absolute;top:0;left:0;width:100%;height:100%}.media-element.is-covered img,.media-element.is-covered video{width:100%;height:auto;-o-object-fit:cover;object-fit:cover}.media-element.is-covered video{height:100%}.media-element .media-color{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
